import { useState } from 'react';
import { RadioGroup } from '@headlessui/react';
import { classNames, presetColorThemes } from '@/lib/utils';

export default function ColorPicker({ className, onColorChange, isOnSetupPage, disabled = false }: { className?: string, onColorChange?: (color: any) => void, isOnSetupPage?: boolean, disabled?: boolean }) {
  const [selectedColor, setSelectedColor] = useState(presetColorThemes[0]);

  const handleColorChange = (color: any) => {
    setSelectedColor(color);
    if (onColorChange)
      onColorChange(color);
  }

  return (
    <RadioGroup
      value={selectedColor}
      onChange={handleColorChange}
      className={classNames(className, "disabled:opacity-50 disabled:cursor-wait")}
      disabled={disabled}
    >
      <RadioGroup.Label className={`block font-medium text-gray-700 ${isOnSetupPage ? 'text-md' : 'text-sm'}`}>
        Choose theme color
      </RadioGroup.Label>
      <div className="flex items-center mt-3 space-x-3">
        {presetColorThemes.map((color) => (
          <RadioGroup.Option
            key={color.name}
            value={color}
            className={({ active, checked }) =>
              classNames(
                color.ringColor,
                active && checked ? 'ring ring-offset-1' : '',
                !active && checked ? 'ring-2' : '',
                'relative -m-0.5 flex cursor-pointer items-center justify-center rounded-full p-0.5 focus:outline-none'
              )
            }
          >
            <RadioGroup.Label as="span" className="sr-only">
              {color.name}
            </RadioGroup.Label>
            <span className={classNames(color.bgColor, 'border h-8 w-8 rounded-full border-black border-opacity-10 transition-all duration-200 hover:brightness-110 hover:opacity-85')} aria-hidden="true" />
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  );
}

